import { createFileRoute } from "@tanstack/react-router";
import HowToTellYourBossYoureWorried from "@/pages/articles/HowToTellYourBossYoureWorried";
export const Route = createFileRoute("/how-to-tell-your-boss-youre-worried")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "How To Tell Your Boss Youre Worried | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Talking to your boss about depression and treatment. Practical advice on workplace conversations and scheduling TMS in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "How To Tell Your Boss Youre Worried | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Talking to your boss about depression and treatment. Practical advice on workplace conversations and scheduling TMS in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/how-to-tell-your-boss-youre-worried",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/how-to-tell-your-boss-youre-worried",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <HowToTellYourBossYoureWorried />;
}
